import { NgClass } from '@angular/common';
import { Component, computed, input, model, OnInit, signal } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

import {
  AvatarBorderType,
  AvatarComponent
} from '@app/shared/components/group-avatars/avatar/proffeo-avatar.component';
import { AvatarSize } from '@app/shared/types/enums/avatar-size.enum';
import { User } from '@app/shared/types/models/user/user.model';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { ProffeoUiInputValue } from '@app/shared/ui/types/input.types';

@Component({
  selector: 'proffeo-select-user-list',
  imports: [MatRadioModule, AvatarComponent, UiInputComponent, NgClass],
  templateUrl: './select-user-list.component.html'
})
export class SelectUserListComponent implements OnInit {
  protected readonly AvatarSize = AvatarSize;
  protected readonly AvatarBorderType = AvatarBorderType;
  protected readonly search = signal<ProffeoUiInputValue>('');
  protected readonly filteredUsers = computed((): User[] => {
    const users = this.originalUsers() ?? [];
    const searchValue = String(this.search() ?? '').toLowerCase();
    return searchValue ? users.filter(user => user.matchesSearch(searchValue)) : users;
  });

  public readonly originalUsers = input<User[]>([]);
  public readonly preselectedUserId = input<string>();
  public readonly selectedUser = model<string>();

  public ngOnInit(): void {
    const preselectedId = this.preselectedUserId();
    if (preselectedId) {
      this.selectedUser.set(preselectedId);
    }
  }

  protected selectUser(user: User): void {
    this.selectedUser.set(user.id);
  }
}
